import { IPoliciesEntityDetails } from './quote.detail.policies';

export const EXAMPLE_DATA: IPoliciesEntityDetails[] = [
  {
    referenceId: 'POL-S4530982881',
    insuredName: 'John Doe',
    inceptionDate: '01/01/2020',
    status: 'ACTIVE',
    premium: 1000,
    endDate: '01/01/2021',
    documentsLink: 'to be implemented',
  },
  {
    referenceId: 'POL-S4530982882',
    insuredName: 'David Miller',
    inceptionDate: '04/08/2021',
    status: 'ACTIVE',
    premium: 1000,
    endDate: '01/01/2022',
    documentsLink: 'to be implemented',
  },
  {
    referenceId: 'POL-S4530986332',
    insuredName: 'Sam Winchester',
    inceptionDate: '04/08/2021',
    status: 'ACTIVE',
    premium: 1000,
    endDate: '01/01/2022',
    documentsLink: 'to be implemented',
  },
];
